import theme from '@/theme';
import { ConversationEntry } from '@d-id/types';
import styled from '@emotion/styled';
import { format } from 'date-fns';

const ConversationItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
`;

const BubbleContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const Bubble = styled.div`
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 400;
    max-width: 80%;
`;

const UserBubble = styled(Bubble)`
    border-radius: 16px 0px 16px 16px;
    border: 1px solid ${theme.colors.secondary.main};
    background-color: ${theme.colors.secondary.main};
    color: ${theme.colors.white};

    align-self: flex-end;
`;

const AgentBubble = styled(Bubble)`
    border-radius: 0px 16px 16px 16px;
    border: 1px solid ${theme.colors.black[300]};
    background-color: ${theme.colors.white};
    color: ${theme.colors.secondary[900]};

    align-self: flex-start;
`;

const Timestamp = styled.div<{ position: 'left' | 'right' }>`
    color: ${theme.colors.black[700]};
    font-size: 10px;
    font-weight: 400;
    align-self: ${props => (props.position === 'left' ? 'flex-start' : 'flex-end')};
`;

interface Props {
    entry: ConversationEntry;
}

export const ConversationItem = ({ entry }: Props) => {
    return (
        <ConversationItemContainer>
            <BubbleContainer>
                <UserBubble>{entry.input}</UserBubble>
                <Timestamp position="right">User - {format(new Date(entry.timestamp), 'MMM d, h:mm a')}</Timestamp>
            </BubbleContainer>

            <BubbleContainer>
                <AgentBubble>{entry.output}</AgentBubble>
                <Timestamp position="left">Agent - {format(new Date(entry.timestamp), 'MMM d, h:mm a')}</Timestamp>
            </BubbleContainer>
        </ConversationItemContainer>
    );
};
